define('core/templates/postMediaImage',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return " height=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.model : depth0)) != null ? stack1.deferredHeight : stack1), depth0))
    + "\" ";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : {};

  return "<a href=\""
    + alias2(alias1((depth0 != null ? depth0.imageUrl : depth0), depth0))
    + "\" target=\"_blank\" rel=\"nofollow\">\n<img src=\""
    + alias2(alias1((depth0 != null ? depth0.thumbnailUrl : depth0), depth0))
    + "\" alt=\""
    + alias2(helpers.gettext.call(alias3,"Thumbnail",{"name":"gettext","hash":{},"data":data}))
    + "\" "
    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.model : depth0)) != null ? stack1.deferredHeight : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ">\n</a>\n";
},"useData":true})

});
